import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import { memo } from 'react';
import { Text } from '@portals/ui-kit';
import { EColors } from '@/_types';
import { ECardType } from '@/_components/success-stories/_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'CardFooter';

type TProps = {
  name?: string;
  description?: string;
  cardType: ECardType;
  isWhite: boolean;
};

export const CardFooter = memo(function Card({
  name,
  description,
  cardType,
  isWhite,
}: TProps) {
  const translations = useTranslations();

  return (
    <div className={cn(BLOCK_NAME, `${BLOCK_NAME}--${cardType}`)}>
      {name && (
        <div className={cn(`${BLOCK_NAME}__name`)}>
          <Text
            color={isWhite ? EColors.WHITE : EColors.BLACK}
            size="title-s"
            text={translations(name)}
          />
        </div>
      )}
      {description && (
        <div className={cn(`${BLOCK_NAME}__description`)}>
          <Text
            color={isWhite ? EColors.WHITE : EColors.BLACK}
            size={cardType === ECardType.SHARE_STORY ? 'body-m' : 'body-s'}
            text={translations(description)}
          />
        </div>
      )}
    </div>
  );
});
